import { Maybe, PaymentTimelineItem } from "@oysterhr/schema"
import { PayoutTimelineItemSimplified } from "./PayoutTimelineItem"
import { useTranslation } from "react-i18next"
import { PayoutTimelineItemList } from "./PayoutTimelineItemList"

interface PayoutTimelineProps {
  timeline?: Maybe<PaymentTimelineItem[]>
}

export const PayoutTimeline = ({ timeline }: PayoutTimelineProps) => {
  const { t } = useTranslation("Invoices")
  if (!timeline) return null

  return (
    <div className="space-y-4 border-b pb-4">
      {timeline.map((item, index) => (
        <div key={index} className="flex flex-col">
          {index === 0 ? (
            <PayoutTimelineItemList item={item} t={t} />
          ) : (
            <PayoutTimelineItemSimplified item={item} t={t} />
          )}
        </div>
      ))}
    </div>
  )
}
